<template>
  <form class="channel-select" @submit.prevent>
    <ChannelSelect
      :channel-id="channelId"
      :person-id="personId"
      :value="value"
      :label="label"
      new-label="Criar novo canal"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="handleSelectChannel"
    />
    <template v-if="showCreateForm">
      <HTextfield
        v-model:value="channel.name"
        class="channel-select__input"
        label="Nome do canal"
        :max-length="35"
        name="channel-rename"
        :disabled="disabled"
        required
      />
      <HSelect
        id="channel-type"
        class="channel-select__type"
        name="channel-type"
        label="Tipo de canal"
        :options="types"
        option-key="label"
        option-label="label"
        :value="typeSelected"
        :disabled="disabled"
        required
        @update:value="handleTypeChange"
      />
    </template>
    <div class="channel-select__buttons">
      <WButton
        variant="cta"
        :disabled="!enableSaveButton"
        :loading="isLoading"
        @click="handleCreateChannel"
      >
        {{ buttonLabel }}
      </WButton>
      <WButton variant="tertiary" :disabled="disabled" @click="handleCancel">
        Cancelar
      </WButton>
    </div>
  </form>
</template>

<script>
import { WButton } from '@alice-health/wonderland-vue'

import { HSelect, HTextfield } from '@/components/shared/atoms'
import ChannelSelect from '@/components/shared/organisms/channel/ChannelSelect.vue'
import { CHANNEL_KINDS, CHANNEL_TYPE_CREATE_OPTIONS } from '@/models/channels'

export default {
  components: {
    ChannelSelect,
    WButton,
    HTextfield,
    HSelect
  },
  props: {
    personId: { type: String, default: undefined },
    value: {
      type: Object,
      default: () => ({})
    },
    channelId: { type: String, default: undefined },
    label: { type: String, default: undefined },
    disabled: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ['input', 'cancel'],
  data() {
    return {
      showCreateForm: false,
      channel: this.getChannelDefaultState(),
      types: [...CHANNEL_TYPE_CREATE_OPTIONS],
      typeSelected: null
    }
  },
  computed: {
    buttonLabel() {
      return this.showCreateForm ? 'Criar e associar' : 'Associar'
    },
    placeholder() {
      return this.showCreateForm ? 'Criar novo canal' : 'Selecione o canal'
    },
    enableSaveButton() {
      if (this.disabled) {
        return false
      }
      return (
        (this.showCreateForm && this.channel.name && this.channel.category) ||
        (!this.showCreateForm && this.channel.id)
      )
    }
  },
  methods: {
    getChannelDefaultState() {
      return {
        id: null,
        name: '',
        kind: CHANNEL_KINDS.CHANNEL,
        category: null,
        subCategory: null,
        subCategoryClassifier: null
      }
    },
    handleSelectChannel(selectedChannel) {
      if (selectedChannel.isNew) {
        this.showCreateForm = true
        this.channel = this.getChannelDefaultState()
        return
      }
      this.showCreateForm = false
      this.channel = selectedChannel
    },
    handleTypeChange(classification) {
      this.typeSelected = classification
      this.channel = {
        ...this.channel,
        ...classification.value
      }
    },
    handleCreateChannel() {
      this.$emit('input', this.channel)
    },
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style scoped lang="scss">
.channel-select {
  border: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-20);
  border-radius: var(--gl-border-radius-sm);
  padding: var(--gl-spacing-04);

  &__input {
    margin-top: var(--gl-spacing-06);
  }

  &__type,
  &__buttons {
    margin-top: var(--gl-spacing-06);
  }
  &__buttons {
    gap: var(--gl-spacing-06);
    display: flex;
  }
}
</style>
